module.exports = __webpack_public_path__ + "img/22213575_s.6c973e22.jpg";